import { cn } from "@/lib/utils/cn";
import * as React from "react";

export const tableBadgeClassName =
  "inline-flex h-[22px] shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-lg border px-2 py-0.5 text-xs leading-4 font-medium transition-[color,box-shadow]";

export function TableBadge({
  className,
  children,
  truncate = false,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { truncate?: boolean }) {
  return (
    <span
      className={cn(tableBadgeClassName, truncate && "max-w-full", className)}
      {...props}
    >
      {truncate ? (
        <span className="min-w-0 truncate">{children}</span>
      ) : (
        children
      )}
    </span>
  );
}
